export default __webpack_public_path__ + "img/pin_icons/bed_b.svg";